import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FlagSelector from '../../../components/issues/FlagSelector';
import {
   DESCRIPTION_MAX_LENGTH,
   getIssueDefinitionForm,
   normalizeIssueDefinition,
   sameIssueDefinition,
   TITLE_MAX_LENGTH,
   validateIssueDefinition
} from './issueDefinition';
import './style.scss';

class IssueDefinitionDialog extends Component {
   constructor(props) {
      super(props);
      const form = getIssueDefinitionForm(props.issue);
      this.state = { form, initial: form, touchedTitle: false };
   }

   componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
         const form = getIssueDefinitionForm(this.props.issue);
         this.setState({ form, initial: form, touchedTitle: false });
      }
   }

   _setField = (field) => (event) => {
      this.setState({ form: { ...this.state.form, [field]: event.target.value } });
   };

   render() {
      const { open, saving, error, priorities, onClose, onSave } = this.props;
      const { form, initial, touchedTitle } = this.state;
      const validation = validateIssueDefinition(form);
      const invalid = validation.titleRequired || validation.titleTooLong || validation.descriptionTooLong;
      const dirty = !sameIssueDefinition(form, initial);
      const titleError = validation.titleTooLong || (touchedTitle && validation.titleRequired);
      const titleHelper = validation.titleTooLong
         ? `Title must be ${TITLE_MAX_LENGTH} characters or fewer.`
         : touchedTitle && validation.titleRequired
            ? 'Title is required.'
            : `${form.title.length}/${TITLE_MAX_LENGTH}`;
      const descriptionHelper = validation.descriptionTooLong
         ? `Description must be ${DESCRIPTION_MAX_LENGTH} characters or fewer.`
         : `${form.description.length}/${DESCRIPTION_MAX_LENGTH}`;

      return (
         <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth='sm'>
            <DialogTitle>Edit issue</DialogTitle>
            <DialogContent>
               <TextField
                  autoFocus
                  fullWidth
                  margin='normal'
                  label='Title'
                  value={form.title}
                  disabled={saving}
                  error={titleError}
                  helperText={titleHelper}
                  onChange={this._setField('title')}
                  onBlur={() => this.setState({ touchedTitle: true })}
               />
               <TextField
                  fullWidth
                  multiline
                  rows={4}
                  margin='normal'
                  label='Description'
                  value={form.description}
                  disabled={saving}
                  error={validation.descriptionTooLong}
                  helperText={descriptionHelper}
                  onChange={this._setField('description')}
               />
               <FlagSelector
                  priorities={priorities}
                  noPriority={form.noPriority}
                  label='Priority'
                  selectionLabel='No priority'
                  variant='standard'
                  disabled={saving}
                  onChange={(noPriority) => this.setState({ form: { ...form, noPriority: noPriority == null ? '' : String(noPriority) } })}
               />
               {error && <div className='issue-definition-error'>{error}</div>}
            </DialogContent>
            <DialogActions>
               <Button disabled={saving} onClick={onClose}>Cancel</Button>
               <Button
                  color='primary'
                  variant='contained'
                  disabled={saving || !dirty || invalid}
                  onClick={() => onSave(normalizeIssueDefinition(form))}
               >
                  {saving ? 'Saving…' : 'Save'}
               </Button>
            </DialogActions>
         </Dialog>
      );
   }
}

IssueDefinitionDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   issue: PropTypes.object,
   priorities: PropTypes.array,
   saving: PropTypes.bool,
   error: PropTypes.string,
   onClose: PropTypes.func.isRequired,
   onSave: PropTypes.func.isRequired
};

export default IssueDefinitionDialog;
